var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"height":"85dvh","overflow-y":"auto"},attrs:{"fluid":""}},[_c('EmployeePTPayrollView',{ref:"employeePTPayrollView",attrs:{"user":_vm.user,"companies":_vm.companiesList,"myPTSubmissions":_vm.myPTSubmissions,"ptFormStatus":_vm.ptFormStatus},on:{"submitPT":_vm.handlePTPayrollSubmission,"refresh":_vm.loadPTData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }